/**
 * Created by rlopez on 11/28/16.
 */
// ActionDetailsView.js

import {View} from 'backbone';
import $ from 'jquery';
import md5 from 'md5';
import RestService from 'RestService.js';
import NotificationService from 'NotificationService.js';
import FormLoadService from 'FormLoadService.js';
import XJService from '../../service/xml/XJService.js';

import template from 'common-views/test-action-modal.ejs';
import * as gridModels from '../dashboard/connections/action-type/ActionGridModels.js';
import util from 'util/Util.js';
import constants from 'Constants.js';
import xjService from 'xml/XJService.js';
import _ from 'lodash';
import jspath from 'jspath';
import random from 'util/random';
import Immutable from 'immutable';
import Spinner                  from 'spin/spin';
import { handleUserMessage, upsertFromAction, deleteFromAction } from '../../service/ai/api.js';

class TestActionModalView extends View {
    initialize(opts) {
        super.initialize(opts);
        $('body').append(this.$el);
        this.template = template;
        this.events = {}; 
      
        // To trim results of binary responses
        this.maxLength = 1048576;

        this.actionName = this.model.get("currentActionDetails").Name || "Action";

        this.serviceTypes = [
            constants.CONNECTION_WEB_SERVICES_STRING_RESULT,
            constants.CONNECTION_WEB_SERVICES_XML_RESULT,
            constants.CONNECTION_REST_GET,
            constants.CONNECTION_REST_POST,
            constants.CONNECTION_REST_PUT,
            constants.CONNECTION_REST_DELETE
        ];
    }

    //Renders the modal dialog
    renderDialog(resolve, reject) {
        
        const buttons = [
            {
                id: 'dialogCancel',
                'text': 'Close',
                class: "modal-cancel-button modal-button",
                click: () => {
                    resolve("Canceled");
                    this.closeModal();
                }
            }
        ];

        this.dialog = util.newDashboardModal(constants.DIALOG_ID,
        {
            title: "Test: " + this.actionName,
            hideTitleBar: false,
            closeEsc: true,
            minWidth: 950,
            width: 950,
            resize: true,
            resizable: true,
            allowMaximize: true,
            onResizeCallback: this._updateModalLayout.bind(this),
            position: { my: 'top', 
                        at: 'center top', 
                        of: 'body'},
            titleBarClass: "dashboard-modal-dialog-titlebar-notification",
            titleClass: "dashboard-modal-title-notification",
            dialogContentClass: "modal-container",
            buttons: buttons,
            closeFx: ()=>{
                this.unbindEvents();
                this.closeModal();
            }
        }).dialog("open");

        this.bindEvents();
    }

    //Creates and render the parameters table
    renderParametersGrid() {
        const $grid = $(constants.TEST_ACTION_CONTAINER);
        let currentModel = this.model.get('currentActionDetails'),
        // The values that will be tested.
        currentModelValues = this.model.get('testValues'),
        self = this,
        currentParameters;

        const updateActions = Immutable.Set([constants.CONNECTION_GOOGLE_UPDATE,
        constants.CONNECTION_DATABASE_UPDATE,
        constants.CONNECTION_DIRECTORY_SERVICES_UPDATE,
        constants.CONNECTION_TEXT_UPDATE,
        constants.CONNECTION_FORMS_UPDATE]);
        const isUpdate = updateActions.contains(currentModel.Type);


        //PF-2845 - Error on editing parameters and testing the action. Params should be ordered by _operation descending in model.
        if (isUpdate){
            // PF-3074 Cloning the array of parameters as these values should be ordered for the Test Action Modal only, not here.
            let sendItemsArray = currentModel.ActionXML.Action.Send.Parameter instanceof Array
                ? currentModel.ActionXML.Action.Send.Parameter
                : [currentModel.ActionXML.Action.Send.Parameter];
            let clonedArray=[...sendItemsArray];
            currentParameters=clonedArray.sort(function(a, b){return b._operation - a._operation});
        }
        else{
            currentParameters = currentModel.ActionXML.Action.Send.Parameter;
        }
        
        let sendItemsToRender = currentParameters instanceof Array
            ? currentParameters
            : [currentParameters];
        
        if (sendItemsToRender.length) {
            $("#noParameters").hide();
            let gridSendObject = util.getGridObject(this, {
                colModel: gridModels.GRID_PARAMETERS_MODEL_TEST_ACTION,
                colNames: gridModels.GRID_PARAMETERS_MODEL_TEST_ACTION_HEADERS,
                height: 'auto',
                scrollOffset: 20,
                autoWidth: true,
                cmTemplate: { 
                    sortable: false 
                },
                onCellSelect: (rowid, iCol, cellcontent, e) => {
                    const colModel = $grid.jqGrid('getGridParam', 'colModel');
                    const columnName = colModel[iCol].name;
            
                    if (columnName === '_value') {
                        const parameter = sendItemsToRender[rowid];
                        if (parameter && parameter._dataType === 'System.Byte') {
                            
                            e.preventDefault();
                            
                            this.handleByteFileUpload(rowid, constants.TEST_ACTION_CONTAINER);
                        }
                    }
                },
            
                afterEditCell: function (rowid, cellname, value, iRow, iCol) {
                    
                    //Fix for column width when editing a cell.
                    const $input = $(`#${iRow}_${cellname}`);
                    if ($input.length > 0) {
                        const cellWidth = $input.closest('td').width();
                        $input.width(cellWidth - 24); 
                    }

                    $("#" + iRow + "_" + cellname).off().on('blur', function () {
                        $(constants.TEST_ACTION_CONTAINER).saveCell(iRow, iCol);
                    });
                },
                gridComplete: function () {
                    const $cgrid = $(this);
                    self._overrideGridStyling($cgrid);
                    self._alignGridHeaders($cgrid, gridModels.GRID_PARAMETERS_MODEL_TEST_ACTION);
                }
            });
            $grid.jqGrid(gridSendObject);           
            this._resizejqGrid($grid);

            let indexOffset = 0;
            if (currentModel.Type === constants.CONNECTION_FORMS_UPDATE){
                self.fillNewRow(constants.TEST_ACTION_CONTAINER, -1, "", constants.CONNECTION_FORM_FORM_INSTANCE_GUID_PARAM_ID, "false",
                constants.CONNECTION_FORM_FORM_INSTANCE_GUID_PARAM_NAME, "-1", "");
                indexOffset = 1;
            }

            _.forEach(sendItemsToRender, (field, index) => {
                self.fillNewRow(constants.TEST_ACTION_CONTAINER, index, field['_fixedValue'], field['_id'], field['_isFixed'],
                    field['_name'], field['_operation'], currentModelValues[index]);
            });
           
        }
        else {
            $("#sendParameters").hide();
            $("#noParameters").show();
        }
    }

    renderTestActionLogGrid() {

        const self = this;
        const logColNames = ['Time', 'Result', 'Code', 'Response', 'Request', 'Result Message'];
        const logColModel = [
            { name: 'time', index: 'time', width: 50 },
            { name: 'result', index: 'result', width: 120 },
            { name: 'code', index: 'code', width: 50, align: 'center' },

            // Hidden fields to store the data for the tabs
            { name: 'responseData', index: 'responseData', hidden: true },
            { name: 'requestData', index: 'requestData', hidden: true },
            { name: 'resultMessage', index: 'resultMessage', hidden: true }
        ];

        const logGridOptions = {
            datatype: 'local',
            colNames: logColNames,
            colModel: logColModel,
            shrinkToFit: true,
            scrollOffset: 0,
            altRows: true,
            height: 'auto',
            rowNum: 1000,
            viewrecords: false,

            onSelectRow: function (rowid, status, e) {
                // Get the data for the row that was just clicked
                const rowData = $(this).jqGrid('getRowData', rowid);

                $("#response-pane textarea").val(rowData.responseData);
                $("#request-pane textarea").val(rowData.requestData);

                if(rowData.resultMessage){
                    $("textarea[name='resultArea']").text(self._stripStyleAndLinkTags(rowData.resultMessage));
                    $("textarea[name='resultArea']").show();
                    $("#divPropResultsTable").hide();
                }

                $('.download-log-icon').show();

                const safeTime = (rowData.time || "").replace(/:/g, '');
                $('#logTabsContent').data('log-time', safeTime);
            },

            gridComplete: function () {
                const $grid = $(this);
                self._overrideGridStyling($grid);
                self._alignGridHeaders($grid, logColModel);

                const rowIds = $grid.jqGrid('getDataIDs');
                if (rowIds && rowIds.length > 0) {
                    $grid.jqGrid('setSelection', rowIds[0], true);
                } else {
                    $('.download-log-icon').hide();
                }
            }
        }

        const $logGrid = $(constants.TEST_ACTION_LOG_GRID);
        $logGrid.jqGrid(logGridOptions);
        this._resizejqGrid($logGrid);
    }

    _logError(err, data) {
        console.log("Error", err);
        let errorMessage = "";

        if (!errorMessage || errorMessage === "") {
            if (err.responseJSON) {
                errorMessage = err.responseJSON.message;
            } else if (err.responseText) {
                errorMessage = err.responseText;
            } else if (err.MESSAGE) {
                if (typeof err.MESSAGE === 'object' && err.MESSAGE['#cdata-section']) {
                    errorMessage = err.MESSAGE['#cdata-section'];
                } else {
                    errorMessage = err.MESSAGE;
                }
            } else {
                errorMessage = err.message || err._message || "An unknown error occurred.";
            }
        }

        const logEntry = {
            time: util.getFormattedTime(),
            result: "Error",
            code: err.CODE || err.status || "-1",
            responseData: data?.responseData || "",
            requestData: data?.requestData || "",
            resultMessage: errorMessage
        };

        //If it's soap or rest and the response is empty it was an unhandled error
        const type = this.model.get("currentActionDetails").Type;
        if(this.serviceTypes.includes(type) && (logEntry.responseData === "" && logEntry.requestData !== "")){
            logEntry.responseData = errorMessage;
            errorMessage = "Unhandled error."
        }

        $("textarea[name='resultArea']").text(this._stripStyleAndLinkTags(errorMessage));
        $("textarea[name='resultArea']").show();
        $("#divPropResultsTable").hide();

        this._addLogEntry(logEntry);
    }

    _logSuccess(data){

        const logEntry = {
            time: util.getFormattedTime(),
            result: data.result || "Success",
            code: data.code || "200",
            responseData: data.responseData,
            requestData: data.requestData
        };

        const type = this.model.get("currentActionDetails").Type;
        if(!this.serviceTypes.includes(type) && (logEntry.responseData && logEntry.responseData !== "")){
            $("textarea[name='resultArea']").text(this._stripStyleAndLinkTags(logEntry.responseData));
            $("textarea[name='resultArea']").show();
            $("#divPropResultsTable").hide();
        }
        this._addLogEntry(logEntry);
    }

    _addLogEntry(entry) {
        const $grid = $(constants.TEST_ACTION_LOG_GRID);
        const newRowId = "log_" + new Date().getTime();
    
        const newRowData = {
            time: entry.time || '',
            result: entry.result || '',
            code: entry.code || '',
            responseData: this._stripStyleAndLinkTags(entry.responseData) || '',
            requestData: entry.requestData || ''
        };
    
        $grid.jqGrid('addRowData', newRowId, newRowData, 'first');
        $('#logTabs a[href="#response-pane"]').tab('show');
        $grid.jqGrid('setSelection', newRowId, true);
    }

    _alignGridHeaders($grid, colModel) {
        if (!$grid || !colModel) return;

        colModel.forEach(column => {
            const align = column.align || 'left';
            const colName = column.name;
            $grid.jqGrid('setLabel', colName, '', { 'text-align': align });
        });
    }

    _overrideGridStyling(grid) {
        grid.addClass('table table-striped table-hover');
        grid.closest('.ui-jqgrid').addClass('jqgrid-table-override');

        grid.closest(".ui-jqgrid-view")
            .find(".ui-jqgrid-htable")
            .addClass('table');
    }

    _updateModalLayout() {

        const $dialogContent = $(constants.DIALOG_ID);
        if (!$dialogContent.length) return;

        const $dialogContainer = $(constants.DIALOG_ID).closest('.ui-dialog');
        if (!$dialogContent.length || !$dialogContainer.length) return;

        const isMaximized = $dialogContainer.data('isMaximized');
        if (isMaximized){
            // Always fit the dialog to the current window
            const newHeight = $(window).height() - 40;
            const newWidth = $(window).width() - 40;

            $dialogContent.dialog('option', {
                'height': newHeight,
                'width': newWidth,
                'position': { my: "center", at: "center", of: window }
            });
        }
        else {
            const windowHeight = $(window).height();
            const windowWidth = $(window).width();

            const dialogHeight = $dialogContainer.outerHeight();
            const dialogWidth = $dialogContainer.outerWidth();

            const newDialogOptions = {};
            let needsResize = false;

            if (dialogHeight > windowHeight) {
                newDialogOptions.height = windowHeight - 40;
                needsResize = true;
            }

            if (dialogWidth > windowWidth) {
                newDialogOptions.width = windowWidth - 40;
                needsResize = true;
            }

            if (needsResize) {
                $dialogContent.dialog('option', newDialogOptions);
            }
        }

        const totalHeight = $dialogContent.height();
        const paramGridPercent = 0.33;
        const responseLogPercent = 0.8;
        
        const paramGridHeight = (totalHeight * paramGridPercent) - 15;
        const responseLogHeight = (totalHeight * responseLogPercent) - 20;
    
        //Set heigh and width of params grid
        const $paramGrid = $(constants.TEST_ACTION_CONTAINER);
        if ($paramGrid.length) {
            const $paramGridContainer = $paramGrid.closest('.ui-jqgrid').find('.ui-jqgrid-bdiv');
            if ($paramGridContainer.length) {
                $paramGridContainer.css('max-height', paramGridHeight + 'px');
                $paramGridContainer.css('overflow-y', 'scroll');
            }
            this._resizejqGrid($paramGrid,8);        
        }
    
        //Set height and width of response log container
        const $responseLogSection = $('#responseLog');
        if ($responseLogSection.length) {
            
            $responseLogSection.css("max-height",responseLogHeight);
    
            const $logGrid = $(constants.TEST_ACTION_LOG_GRID);
            const $logGridContainer = $logGrid.closest('.ui-jqgrid').find('.ui-jqgrid-bdiv');
            if ($logGridContainer.length) {
                $logGridContainer.css('max-height', (responseLogHeight - 20) + 'px');
                $logGridContainer.css('overflow-y', 'auto');
            }
            this._resizejqGrid($logGrid);
            
            const $textareas = $dialogContent.find(".tab-content textarea");
            if ($textareas.length) {
                const $tabHeaders = $dialogContent.find(".nav-tabs");
                const tabHeaderHeight = $tabHeaders.outerHeight(true) || 0;
                $textareas.css('max-height', responseLogHeight - tabHeaderHeight - 20);
            }
        }

        const $resultGrid = $(constants.GRID_RESULTS_CONTAINER);
        this._resizejqGrid($resultGrid);
    
        this._reCenterDialog();
    }

    _reCenterDialog(){
        const $dialogContent = $(constants.DIALOG_ID);
        $dialogContent.dialog('option', 'position', { 
            my: 'center', 
            at: 'center', 
            of: window 
        });
    }

    _stripStyleAndLinkTags(htmlString) {
        if (!htmlString || typeof htmlString !== 'string') {
            return "";
        }    
        let cleaned = htmlString;        
        //Remove all <style>...</style> blocks
        cleaned = cleaned.replace(/<style\b[^>]*>[\s\S]*?<\/style>/gim, "");        
        //Remove all <link ...> tags
        cleaned = cleaned.replace(/<link\b[^>]*(\/>|\s*<\/link>|\s*>)/gim, "");        
        return cleaned;
    }

    afterSaveCell(rowId, cellName, value, iRow, iCol) {
        let currentModelValues = this.model.get('testValues');
        currentModelValues[rowId][cellName] = value;

        this.model.set('testValues', currentModelValues, {silent: true});
        this.model.set('hasChanges', true, {silent: true});
        //this.model.trigger('change');
        console.log("Model After Save Cell", currentModelValues);
    }

    onSelectRow() {
    }

    onCellSelect() {
    }

    onDoubleClickRow(){
    }

    //Adds row to jqgrid
    fillNewRow(grid, index, _fixedValue, _id, _isFixed, _name, _operation, _value) {
        if(grid!==constants.GRID_RESULTS_CONTAINER) {
            let rowData = {
                '_fixedValue': _fixedValue,
                '_id': _id,
                '_isFixed': _isFixed,
                '_name': _name,
                '_operation': _operation,
                '_value': _value
            };
            $(grid).addRowData(index, rowData);
            let currentModelValues = this.model.get('testValues');
            currentModelValues[index] = rowData;
        }
        else{
            let rowData = {
                '_value': _fixedValue
            };
            $(grid).addRowData(index, rowData);
        }
    }

    setRow(rowId, e) {
        console.log('before select row', e);
        $(`#${e.currentTarget.id}`).jqGrid('setSelection', rowId);
    }//

    afterEditCell(rowId, cellName, value, iRow, iCol) {
        $("#" + iRow + "_" + cellName).on('blur', function () {
            $(constants.TEST_ACTION_CONTAINER).saveCell(iRow, iCol);
        });
    }

    performConnect() {
        let currentActionValues = this.model.get('currentActionDetails').ActionXML.Action;
        let testValues = this.model.get('testValues');
        console.log('Current Model available', currentActionValues);
        console.log('Current Tests available', testValues);
        // Getting the connection first as it is requirement for testing and action in some action types.
        RestService.getConnectionDetails(currentActionValues["_connectionId"]).then((connectionDetails) => {
            console.log("Connection Details", connectionDetails);
            let connectionXML = FormLoadService._decompressForm(connectionDetails.ConnectionXML['#cdata-section']);
            console.log("Uncompressed XML", connectionXML);
            let connectionObject = XJService.toJSON(connectionXML);
            console.log("Connection on Action Modal", connectionObject);

            // PF-9883 Dashboard - Unnecessary space is shown when test connections in dashboard
            // Hide empty result area
            $("textarea[name='resultArea']").css('display', 'none');
           
            switch (connectionObject.Connection['_type']){
                case constants.DATABASES_GROUP_TYPE:
                case constants.DIRECTORY_GROUP_TYPE:
                    this.testDatabaseOrDirectoryAction(connectionObject.Connection,currentActionValues,testValues);
                    break;
                case constants.WEB_GROUP_TYPE:
                    this.testWebServiceAction(connectionObject.Connection,currentActionValues,testValues);
                    break;
                case constants.FORMS_GROUP_TYPE:
                    this.testFormAction(connectionObject.Connection,currentActionValues,testValues);
                    break;
                case constants.GOOGLE_GROUP_TYPE:
                case constants.GOOGLE_ACTION_DETAIL_VIEW:
                    this.testGoogleAction(connectionObject.Connection,currentActionValues,testValues);
                    break;
                case constants.TEXT_GROUP_TYPE:
                    this.testTextAction(connectionObject.Connection,currentActionValues,testValues);
                    break;
                case constants.REST_GROUP_TYPE:
                    this.testWebServiceActionREST(connectionObject, currentActionValues, testValues);
                    break;
                case constants.VECTORDB_GROUP_TYPE:
                    this.testVectorDBAction(connectionObject.Connection, currentActionValues, testValues);
                    break;
                default:
                    this.testDatabaseOrDirectoryAction(connectionObject.Connection,currentActionValues,testValues);
                    break;
            }

        }).catch((err => {
            console.log('Error Retrieving Connection Details Data ', err);
            NotificationService.error('Error Retrieving Connection Details Data. ' + (err.MESSAGE || err.message) || err);
        }));
    }

    async testVectorDBAction(connection, action, testValues) {
        const connectionId = action['_connectionId'];
        const actionType = action['_type'];
        const sendParams = action.Send.Parameter instanceof Array ? action.Send.Parameter : [action.Send.Parameter];

        switch (actionType) {
            case constants.CONNECTION_VECTORDB_QUERY:
                return this._testVectorDBQuery(connectionId, sendParams, testValues);
            case constants.CONNECTION_VECTORDB_UPSERT:
                return this._testVectorDBUpsert(connectionId, sendParams, testValues);
            case constants.CONNECTION_VECTORDB_DELETE:
                return this._testVectorDBDelete(connectionId, sendParams, testValues);
            default:
                this._logError({ message: 'Unknown Vector DB action type: ' + actionType });
        }
    }

    async _testVectorDBQuery(connectionId, sendParams, testValues) {
        let userMessage = '';
        sendParams.forEach((param, index) => {
            const val = testValues[index] && testValues[index]._value ? testValues[index]._value : '';
            if (param['_name'] === 'userMessage') userMessage = val;
        });

        if (!userMessage) {
            this._logError({ message: 'userMessage is required' });
            return;
        }

        const spinner = new Spinner().spin($('#dialog').get(0));
        const requestData = JSON.stringify({ userMessage, vectorDbConnectionId: connectionId });

        try {
            const result = await handleUserMessage(userMessage, [], '', connectionId);
            spinner.stop();

            const row = {};
            const currentModel = this.model.get('currentActionDetails');
            const receiveParams = currentModel.ActionXML.Action.Receive.Parameter;
            (Array.isArray(receiveParams) ? receiveParams : [receiveParams]).forEach(p => {
                const val = result[p._value] ?? result[p._name] ?? '';
                row[p._value] = Array.isArray(val) ? val.join(', ') : val;
            });

            this._logSuccess({ result: 'Success', code: '200', requestData });
            this.createResultsGrid([row]);
        } catch (err) {
            spinner.stop();
            this._logError(err, { requestData });
        }
    }

    async _testVectorDBUpsert(connectionId, sendParams, testValues) {
        const fields = [];
        sendParams.forEach((param, index) => {
            const val = testValues[index] && testValues[index]._value ? testValues[index]._value : '';
            fields.push({ name: param['_name'], value: val });
        });

        if (!fields.some(f => f.name === 'instanceId' && f.value)) {
            this._logError({ message: 'instanceId is required' });
            return;
        }

        const spinner = new Spinner().spin($('#dialog').get(0));
        const requestData = JSON.stringify({ connectionId, fields });

        try {
            const result = await upsertFromAction(connectionId, fields);
            spinner.stop();

            const row = {};
            const currentModel = this.model.get('currentActionDetails');
            const receiveParams = currentModel.ActionXML.Action.Receive.Parameter;
            (Array.isArray(receiveParams) ? receiveParams : [receiveParams]).forEach(p => {
                row[p._value] = result[p._value] ?? result[p._name] ?? '';
            });

            this._logSuccess({ result: 'Success', code: '200', requestData });
            this.createResultsGrid([row]);
        } catch (err) {
            spinner.stop();
            this._logError(err, { requestData });
        }
    }

    async _testVectorDBDelete(connectionId, sendParams, testValues) {
        let instanceId = '';
        sendParams.forEach((param, index) => {
            const val = testValues[index] && testValues[index]._value ? testValues[index]._value : '';
            if (param['_name'] === 'instanceId') instanceId = val;
        });

        if (!instanceId) {
            this._logError({ message: 'instanceId is required' });
            return;
        }

        const spinner = new Spinner().spin($('#dialog').get(0));
        const requestData = JSON.stringify({ connectionId, instanceId });

        try {
            const result = await deleteFromAction(connectionId, instanceId);
            spinner.stop();

            const row = {};
            const currentModel = this.model.get('currentActionDetails');
            const receiveParams = currentModel.ActionXML.Action.Receive.Parameter;
            (Array.isArray(receiveParams) ? receiveParams : [receiveParams]).forEach(p => {
                row[p._value] = result[p._value] ?? result[p._name] ?? '';
            });

            this._logSuccess({ result: 'Success', code: '200', requestData });
            this.createResultsGrid([row]);
        } catch (err) {
            spinner.stop();
            this._logError(err, { requestData });
        }
    }

    testDatabaseOrDirectoryAction(connection,action,testValues){
        let url,
            hashedUserName = md5(connection['_username']),
            hashedPassword = md5(connection['_password']);
            console.log("Compressed User name", hashedUserName);
        switch (action["_type"]) {
            case constants.CONNECTION_DATABASE_SELECT:
                url = `${connection['_url']}/ExecuteSqlSelect`;
                break;
            case constants.CONNECTION_DATABASE_UPDATE:
                url = `${connection['_url']}/ExecuteSqlUpdate`;
                break;
            case constants.CONNECTION_DATABASE_INSERT:
                url = `${connection['_url']}/ExecuteSqlInsert`;
                break;
            case constants.CONNECTION_DATABASE_DELETE:
                url = `${connection['_url']}/ExecuteSqlDelete`;
                break;
            case constants.CONNECTION_DATABASE_STORE_PROCEDURE:
                url = `${connection['_url']}/ExecuteSqlProcedure`;
                break;

            case constants.CONNECTION_DIRECTORY_SERVICES_SELECT:
                url = `${connection['_url']}/ExecuteLdapSelect`;
                break;
            case constants.CONNECTION_DIRECTORY_SERVICES_INSERT:
                url = `${connection['_url']}/ExecuteLdapInsert`;
                break;
            case constants.CONNECTION_DIRECTORY_SERVICES_UPDATE:
                url = `${connection['_url']}/ExecuteLdapUpdate`;
                break;
            case constants.CONNECTION_DIRECTORY_SERVICES_DELETE:
                url = `${connection['_url']}/ExecuteLdapDelete`;
                break;
        }

        // Starting to build the XML object.
        let requestObject = [];
        requestObject.push('versionNumber=1.09');
        requestObject.push(`username=${hashedUserName}`);
        requestObject.push(`datasourceId=${connection['_datasourceId']}`);
        requestObject.push(`password=${hashedPassword}`);
        
        let xmlParams = `xmlParams=` +
            `<request id="${action['_id']}" type="${action['_type']}">\n` +
            `  <send pageNumber="0" rowsPerPage="100">\n`;
        
        testValues.forEach((testValue, index) => {
            if (testValue && testValue._value) {
                xmlParams +=
                    `    <parameter id="${action.Send.Parameter[index]['_id']}" column="${action.Send.Parameter[index]['_value']}" operation="${action.Send.Parameter[index]['_operation']}">\n` +
                    `      <value>${util.escapeStringForConnectionsTest(testValue._value)}</value>\n` +
                    `    </parameter>\n`
            }
            else {
                xmlParams +=
                    `    <parameter id="${action.Send.Parameter[index]['_id']}" column="${action.Send.Parameter[index]['_value']}" operation="${action.Send.Parameter[index]['_operation']}">\n` +
                    `      <value/>\n` +
                    `    </parameter>\n`
            }
        });
        if (!action.Receive["_distinctResults"]) {
            xmlParams +=
                `  </send>\n` +
                `  <receive>\n`;
        }
        else {
            xmlParams +=
                `  </send>\n` +
                `  <receive distinctResults="${action.Receive["_distinctResults"]}">\n`;
        }
        action.Receive.Parameter.forEach((param) => {
            xmlParams +=
                `    <parameter id="${param['_id']}" column="${param['_value']}"/>\n`
        });
        xmlParams +=
            `  </receive>\n`;
        if (action.hasOwnProperty('DistinguishedName')) {
            xmlParams +=
                `  <tables>\n` +
                `    <table name="${action.DistinguishedName}"></table>\n` +
                `  </tables>\n`
        }
        else if (action.Tables.Table["_name"] !== "") {
            xmlParams +=
                `  <tables>\n` +
                `    <table name="${action.Tables.Table["_name"]}"></table>\n` +
                `  </tables>\n`
        }
        else {
            xmlParams +=
                `  <tables/>\n`
        }
        xmlParams += '</request>';
        requestObject.push(xmlParams);

        switch (connection["_type"]) {
            case '1':
                requestObject.push('datasourceType=sql');
                requestObject.push(`databaseId=${connection['_databaseId'] }`);
                break;
            case '2':
                requestObject.push('datasourceType=ldap');  
                requestObject.push(`databaseId=${connection['_baseDnId']}`);
                break;
        }
        let testActionObject = {
            URL: url,
            method: 'WebServiceCall',
            requestObject: escape(requestObject.join('&')),
            webServiceType: 'POST',
            targetNamespace: '',
            username: constants.DEFAULT_GROUP_ID,
            password: constants.DEFAULT_GROUP_ID,
            requestHeader: constants.DEFAULT_GROUP_ID
        };

        RestService.checkAction(testActionObject).then((result) => {
            this.renderResultsGrid(result);
        }).catch((err => {
            this._logError(err);
        }));
    }

    //Transform dot notation parameter name to XML string
    buildXMLStringFromWSParamName(parameters, testValues) {
        let objMaster = {};
        if (parameters && parameters.length > 0) {
            $.each(parameters, function (index, _parameter) {
                let paramNameSplit = _parameter._value.replaceAll(constants.CONNECTION_DOT_PLACEHOLDER, '&_VarWDot_&').split(".");
                let _current = {};
                let _previous = {};
                let _value = testValues.filter(tv => tv._id === _parameter._id);
                if (paramNameSplit.length > 1) {
                    let paramValue = _value[0] ? _value[0]._value : '';
                    if(paramValue.includes('[')){
                        let paramArray = paramValue.substring(1 ,paramValue.length - 1).split(",");
                        for (let i = 0; i < paramArray.length; i++) {
                            let splittedNameArray = '';
                            for (let j = paramNameSplit.length - 1; j >= 0; j--) {
                                if (j === paramNameSplit.length - 1){
                                    _previous = paramArray[i];
                                }

                                let splittedName = '';
                                if (paramNameSplit[j].includes('[]')){
                                    splittedName = paramNameSplit[j].replace('[]', '').replaceAll('&_VarWDot_&', '.').split('@')[0] + '_array' + i;
                                }else{
                                    splittedName = paramNameSplit[j].replace('[]', '').replaceAll('&_VarWDot_&', '.').split('@')[0];
                                }
                                
                                splittedNameArray = "_" + i;
                                let splittedParameter = paramNameSplit[j].split('@')[1];
        
                                if (!_current[splittedName]) {
                                    _current[splittedName] = !splittedParameter ?  _previous : { ["_"+splittedParameter] : _previous};
                                } else {
                                    _current[splittedName].push(!splittedParameter ?  _previous : { ["_"+splittedParameter] : _previous});
                                }
                                _previous = _current;
                                _current = {};
                            }
        
                            _.merge(objMaster, _previous);
                        }
                    }else{
                        for (let i = paramNameSplit.length - 1; i >= 0; i--) {
                            if (i === paramNameSplit.length - 1){
                                _previous = _value[0] ? _value[0]._value : '';
                            }
    
                            let splittedName = paramNameSplit[i].replace('[]', '').replaceAll('&_VarWDot_&', '.').split('@')[0];
                            let splittedParameter = paramNameSplit[i].split('@')[1];
    
                            if (!_current[splittedName]) {
                                _current[splittedName] = !splittedParameter ?  _previous : { ["_"+splittedParameter] : _previous};
                            } else {
                                _current[splittedName].push(!splittedParameter ?  _previous : { ["_"+splittedParameter] : _previous});
                            }
                            _previous = _current;
                            _current = {};
                        }
    
                        _.merge(objMaster, _previous);
                    }               
                } else if (paramNameSplit.length === 1) {
                    objMaster[paramNameSplit[0]] = _value[0] ? _value[0]._value : '';
                }
            });
        }

        const rootRandomElement = "root_" + random.getRandomInt(0, 9999999);
        let rootElement = [];
        rootElement[rootRandomElement] = objMaster;
        let xmlString = xjService.toXML(rootElement);
        xmlString = xmlString.replace("<" + rootRandomElement + ">", "").replace("</" + rootRandomElement + ">", "");

        if (xmlString.length > 0){
            for (let i = 0; i < xmlString.length; i++){
                var arraysub = xmlString.substring(i);
                if (arraysub.startsWith("_array"))
                {
                    let openingCharacter = arraysub.indexOf(">");
                    xmlString = xmlString.substring(0, i) + xmlString.substring(i + openingCharacter, xmlString.length)
                }
            }
        }

        return xmlString;
    }

    testWebServiceAction(connection,action,testValues){
        let url = `${connection['_url']}`,
            requestObject = '';
        
        // SOAP request
        if (action._method === "SOAP") {
            requestObject = this.buildXMLStringFromWSParamName(action.Send.Parameter, testValues);
            requestObject = encodeURIComponent(requestObject);
        }
        // POST/GET request
        else {
            let requestParams = [];
            testValues.forEach((testValue, index) => {
                requestParams.push(`${action.Send.Parameter[index]['_value']}=${testValue._value}`);
            });

            requestObject = requestParams.join("&");
        }

        let testActionObject = {
            URL: url,
            method: action['_operationUrl'],
            requestObject: requestObject,
            webServiceType: action['_method'] === "SOAP" ? "SOAPNET" : action['_method'],
            targetNamespace: action['_targetNamespace'],
            username: connection['_username'],
            password: connection['_password'],
            requestHeader: constants.DEFAULT_GROUP_ID,
            useNameSpace: connection['_useNameSpace'],
            wsdlURL: connection['_wsdlUrl'],
            connectionGUID: connection['_id'],
            wsdlSource: connection['_wsdlSource']
        };
               
        const logEntry = {};

        RestService.checkAction(testActionObject).then((result) => {
            console.log("Check Action Result", result);
            const metadata = this._getMetadata(result.RESULT.METADATA);
            logEntry.responseData = metadata.response;
            logEntry.requestData = metadata.request;

            if (action._method === 'SOAP') {
                this.renderResultsGridWebService(result, logEntry);
            } else {
                this.renderResultsGridWebServicePOST(result, logEntry);
            }
        }).catch(((err) => {
            if(err.METADATA){
                const metadata = this._getMetadata(err.METADATA);
                logEntry.responseData = metadata.response;
                logEntry.requestData = metadata.request;
            }

            const error = err?.ERROR || err;
            this._logError(error, logEntry);
        }));
    }

    testFormAction(connection,action,testValues){
        let requestObject='',testActionObject={};
        if(action['_type'] === constants.CONNECTION_FORMS_READ) {
            requestObject += `<Expression type="reportingFilter">\n`;
            
            let expressionChanged = false;
            let testValuesCount = 0;

            testValues.forEach((testValue, index) => {
                if (testValue['_value']) {
                    expressionChanged = true;
                    let dataType = action.Fields.Field.find(field => {
                        return field['_id'] === action.Send.Parameter[index]['_value']
                    })['_DataType'];
                    let operator = '';
                    let valueToFind = testValue['_value'];
                    switch (action.Send.Parameter[index]['_operation']) {
                        case '0':
                            operator = '==';
                            break;
                        case '1':
                            operator = 'lt';
                            break;
                        case '2':
                            operator = 'gt';
                            break;
                        case '3':
                            operator = 'lt=';
                            break;
                        case '4':
                            operator = 'gt=';
                            break;
                        case '5':
                            operator = 'ltgt';
                            break;
                        case '6':
                            operator = 'like';
                            valueToFind = testValue['_value'].replace(/\*/g, '%');
                            break;
                        default:
                            operator = '==';
                            break;
                    }

                    if (testValuesCount > 0) {
                        requestObject += `     <Operator type="and"/>`;
                    }

                    requestObject +=
                        `     <Expression type="reportingFilter">\n` +
                        `         <Argument type="reporting_datasourceField" value="${action.Send.Parameter[index]['_value']}" dataType="${dataType}"/>\n` +
                        `         <Operator type="${operator}"/>\n` +
                        `         <Argument type="reporting_literal" value="${valueToFind}" dataType="${dataType}"/>\n` +
                        `     </Expression>`;
                    testValuesCount++;                    
                }
            });

            if(testValues && testValues.length && expressionChanged){
                requestObject+=`\n</Expression>`;
                requestObject = util.escapeStringForConnectionsTest(requestObject);
            }
            else{
                requestObject = '';
            }

            testActionObject = {
                connectionId: action['_connectionId'],
                actionId: this.model.get('actionId'),//action['_id'],
                filter:  requestObject,
                contextFormId: constants.DEFAULT_GROUP_ID
            };
            
            RestService.checkGeneralAction(testActionObject, '/Integration/ReadFormInstance').then((result) => {
                const logEntry = {
                    responseData: "",
                };
                if (!this.renderResultsGridForm(result)) {
                    logEntry.responseData = 'No records were returned.';
                }

                this._logSuccess(logEntry);
            }).catch((err => {
                this._logError(err);
            }));
        }
        else{
            requestObject+=`<Fields>\n`;
            testValues.forEach(testValue => {
                if (testValue._id !== constants.CONNECTION_FORM_FORM_INSTANCE_GUID_PARAM_ID) {
                    const sendParams = action.Send.Parameter.filter(i => i._id === testValue._id);
                    if (sendParams.length > 0) {
                        const fields = action.Fields.Field.filter(i => i._id === sendParams[0]._value);
                        if (fields.length > 0) {
                            const field = fields[0];
                            const _meta = field["_Meta"].toLowerCase(); //We must be sure this is rendered as lower case
                            requestObject +=
                                `  <Field id="${field['_id']}" Name="${field['_Name']}" DataType="${field["_DataType"]}" InternalFlag="${field['_InternalFlag']}"` +
                                ` IsOut="${field['_IsOut']}" Meta="${_meta}" oldId="${field["_oldId"]}"`;
                            let foundParam = action.Send.Parameter.filter(parameter => {
                                return parameter['_value'] === field['_id']
                            });
                            if (foundParam.length > 0) {
                                requestObject += `>\n`;
                                requestObject += `    <value>${testValue['_value']}</value>\n`;
                                requestObject += `  </Field>\n`
                            }
                            else {
                                requestObject += `/>\n`;
                            }
                        }
                    }
                }
            });

            requestObject+=`</Fields>`;
            let resourceUrl='';
            let actionResultMessage = "";
            if(action['_type'] === constants.CONNECTION_FORMS_INSERT) {
                testActionObject = {
                    connectionId: action['_connectionId'],
                    fieldsXML: util.escapeStringForConnectionsTest(requestObject).replace(/&amp;/g,'&amp;amp;'), //Forms use a special sign for ampersand
                    contextFormId: constants.DEFAULT_GROUP_ID
                };
                resourceUrl='/Integration/InsertFormInstance';
                actionResultMessage = "insertion";
            }
            else if(action['_type'] === constants.CONNECTION_FORMS_UPDATE){                
                let formInstanceGUID = 0;             
                if (testValues[-1]){ //Index -1 is used on send parameters grid for the CONNECTION_FORM_FORM_INSTANCE_GUID_PARAM_ID parameter, which is a default parameter
                    formInstanceGUID = testValues[-1]['_value'];
                }

                testActionObject = {
                    connectionId: action['_connectionId'],
                    formInstanceGUID: formInstanceGUID,
                    fieldsXML:  util.escapeStringForConnectionsTest(requestObject).replace(/&amp;/g,'&amp;amp;'), //Forms use a special sign for ampersand
                    contextFormId: constants.DEFAULT_GROUP_ID
                };
                resourceUrl='/Integration/UpdateFormInstance';
                actionResultMessage = "update";
            }
            RestService.checkGeneralAction(testActionObject,resourceUrl).then((result) => {
                const logEntry = {};
                logEntry.responseData = `Instance ${actionResultMessage} was successful.`;
                this._logSuccess(logEntry);

            }).catch((err => {
                let detailedErrorMessage = "";

                if (err.CODE === constants.CONNECTION_FORM_INSTANCE_NOT_AVAILABLE_ERROR_CODE) {
                    detailedErrorMessage = constants.CONNECTION_FORM_INSTANCE_NOT_AVAILABLE_ERROR_MESSAGE;
                }

                logEntry.responseData = detailedErrorMessage;
                
                this._logError(err, logEntry)
            }));
        }
    }

    renderResultsGridForm(results) {
        let found = false;
        let currentModel = this.model.get('currentActionDetails');
       
        
        // Prepare jqgrid
           if (results.ReportingDataXML !== null) {
            this.showResultsDiv(true);
            found = true
            let responseObject = results.ReportingDataXML.Row instanceof Array ? results.ReportingDataXML.Row : [results.ReportingDataXML.Row];
         
            const data = [];

            // For each record
            _.forEach(responseObject, (field, index) => {
                let row = {};

                currentModel.ActionXML.Action.Receive.Parameter.forEach((rp) => {
                    const idx = currentModel.ActionXML.Action.Fields.Field.findIndex(field => {
                        return field['_id'] === rp['_value']
                    });
                    row[rp._value] = field['@C' + idx];
                })

                data.push(row);

             });

            this.createResultsGrid(data);
                
        } else {
            this.showResultsDiv(false);
        }
        return found;
    }

    showResultsDiv(show){
        let display = "none";
        if (show){
            display = "block";
        }

        $(constants.GRID_RESULTS_CONTAINER_DIV).css("display", display);
    }

    testGoogleAction(connection,action,testValues){
       
        let xmlParams=`<request id="null" type="-1">\n  <send pageNumber="0" rowsPerPage="100"/>\n`;
        let testParams = this.model.get('testValues');

        if(action.Send.Parameter.length > 0){
            xmlParams = `<request id="null" type="-1">\n  <send pageNumber="0" rowsPerPage="100">\n`;
            action.Send.Parameter.forEach((parameter, index) => {
                var name = testParams.filter(function(p){
                    return p._id === action.Send.Parameter[index]['_id'];
                    });
                    xmlParams +=
                    `<parameter id="${action.Send.Parameter[index]['_id']}" name="${action.Send.Parameter[index]['_value']}" operator="${action._type === constants.CONNECTION_GOOGLE_INSERT ?'-1':action.Send.Parameter[index]['_operation']}">\n` +
                    `<value>${name[0]._value}</value>\n` +
                    `</parameter>\n`; 
            });
            xmlParams += `</send>\n`;
        }

        if(action.Receive.Parameter.length > 0){
            xmlParams += `<receive>\n`;
            action.Receive.Parameter.forEach((parameter, index) => {
                if (action._type === '85') { //Type 85 - SELECT
                    xmlParams +=
                        `<parameter id="${parameter._id}" name="${parameter._value}"/>\n`;
                }else{
                    if (testParams.length > 0){
                        var name = testParams.filter(function(p){
                            return p._name.toLowerCase() === action.Receive.Parameter[index]['_value'].toLowerCase();
                        });
                        xmlParams +=
                            `<parameter id="${action.Receive.Parameter[index]['_id']}" name="${action.Receive.Parameter[index]['_value']}" operator="${action.Receive.Parameter[index]['_operation']}">\n` +
                            `<value>${name[0]._value}</value>\n` +
                            `</parameter>\n`;
                    }
                }
            });
            xmlParams += `</receive>\n`;
        }else if(action.Send.Parameter.length > 0){
            xmlParams += `<receive/>\n`;
        }

        xmlParams+='</request>';

        let testActionObject = {
            refresh_token: connection['_refreshCode'],
            access_token: connection['_accessCode'],
            fileId: connection['_fileId'],
            sheetName: connection['_spreadsheet'],
            xmlParams: util.escapeStringForConnectionsTest(xmlParams)
        };
        let resourceUrl='';
        switch(action["_type"]){
            case constants.CONNECTION_GOOGLE_UPDATE:resourceUrl='/Integration/GoogleSpreadSheetUpdate';break;
            case constants.CONNECTION_GOOGLE_INSERT:resourceUrl='/Integration/GoogleSpreadSheetInsert';break;
            case constants.CONNECTION_GOOGLE_SELECT:resourceUrl='/Integration/GoogleSpreadSheetSelect';break;
            case constants.CONNECTION_GOOGLE_DELETE:resourceUrl='/Integration/GoogleSpreadSheetDelete';break;
            default:resourceUrl='/Integration/GoogleSpreadSheetSelect';break;
        }


        RestService.checkGeneralAction(testActionObject,resourceUrl).then((result) => {
            console.log("Check Action Result", result);
            this.renderResultsGridGoogle(result);
        }).catch((err => {
            this._logError(err);
        }));
    }

    testTextAction(connection, action, testValues) {

        let xmlParams = `<request id="${action['_id']}" type="${action['_type']}">\n  <send pageNumber="0" rowsPerPage="100">\n`;
        testValues.forEach((testValue, index) => {
            const parameterArr = action.Send.Parameter.filter(i => i._id === testValue._id && i._operation === testValue._operation);
            if (parameterArr && parameterArr.length > 0) {
                let parameter = parameterArr[0];
                if (testValue) {
                    xmlParams +=
                        `    <parameter id="${parameter['_id']}" column="${parameter['_value']}" operation="${parameter['_operation']}">\n` +
                        `      <value>${util.escapeStringForConnectionsTest(testValue['_value'])}</value>\n` +
                        `    </parameter>\n`
                }
                else {
                    xmlParams +=
                        `    <parameter id="${parameter['_id']}" column="${parameter['_value']}" operation="${parameter['_operation']}">\n` +
                        `      <value/>\n` +
                        `    </parameter>\n`
                }
            }
        });
        xmlParams += '  </send>';

        if (!action.Receive["_distinctResults"]) {
            xmlParams += `  <receive>\n`;
        }
        else {
            xmlParams += `  <receive distinctResults="${action.Receive["_distinctResults"]}">\n`;
        }

        action.Receive.Parameter.forEach((param) => {
            xmlParams +=
                `    <parameter id="${param['_id']}" column="${param['_value']}"/>\n`
        });

        xmlParams += '</receive>\n</request> ';

        if (connection._useProxy === 'true') {
            let requestObject = [];
            requestObject.push('versionNumber=1.09');
            requestObject.push(`username=${md5(connection['_username'])}`);
            requestObject.push(`datasourceId=${connection['_datasourceId']}`);
            requestObject.push(`password=${md5(connection['_password'])}`);

            requestObject.push('xmlParams=' + xmlParams);
            requestObject.push('datasourceType=csv');
            requestObject.push(`databaseId=${connection['_databaseId']}`);

            let resourceUrl = '';
            switch (action["_type"]) {
                case constants.CONNECTION_TEXT_UPDATE: resourceUrl = '/ExecuteCsvUpdate'; break;
                case constants.CONNECTION_TEXT_INSERT: resourceUrl = '/ExecuteCsvInsert'; break;
                case constants.CONNECTION_TEXT_SELECT: resourceUrl = '/ExecuteCsvSelect'; break;
                case constants.CONNECTION_TEXT_DELETE: resourceUrl = '/ExecuteCsvDelete'; break;
                default: resourceUrl = '/ExecuteCsvSelect'; break;
            }

            let testActionObject = {
                URL: connection['_url'] + resourceUrl,
                method: 'WebServiceCall',
                requestObject: escape(requestObject.join('&')),
                webServiceType: 'POST',
                targetNamespace: '',
                username: constants.DEFAULT_GROUP_ID,
                password: constants.DEFAULT_GROUP_ID,
                requestHeader: constants.DEFAULT_GROUP_ID
            };


            RestService.checkAction(testActionObject).then((result) => {
                this.renderResultsGrid(result);
            }).catch((err => {
                this._logError(err);
            }));
        }
        else {
            let resourceUrl = '';
            switch (action["_type"]) {
                case constants.CONNECTION_TEXT_UPDATE: resourceUrl = '/ExecuteCsvUpdate'; break;
                case constants.CONNECTION_TEXT_INSERT: resourceUrl = '/ExecuteCsvInsert'; break;
                case constants.CONNECTION_TEXT_SELECT: resourceUrl = '/ExecuteCsvSelect'; break;
                case constants.CONNECTION_TEXT_DELETE: resourceUrl = '/ExecuteCsvDelete'; break;
                default: resourceUrl = '/ExecuteCsvSelect'; break;
            }

            let testActionObject = {
                username: md5(connection['_username']),
                password: md5(connection['_password']),
                datasourceType: 'csv',
                datasourceId: connection['_datasourceId'],
                xmlParams: xmlParams,
                databaseId: connection['_databaseId'],
                versionNumber: '1.09'
            };

            RestService.checkGeneralActionNoProxy(testActionObject, connection['_url'] + resourceUrl).then((result) => {
                console.log("Check Action Result", result);
                this.renderResultsGrid(result);                
            }).catch((err => {
                this._logError(err);
            }));
        }
    }

    // PF-9505 Add grid after processing data to make rendering faster
    createResultsGrid(data) {

        const spinner = new Spinner().spin($(constants.DIALOG_ID).get(0));

        if (data.length) {
            const self = this;

            const $grid = $(constants.GRID_RESULTS_CONTAINER);
            const grid = $grid[0];
            if (grid && grid.grid) { //PF-10893, Testing the App or Google connection actions returns the records only once despite the operator used
                $grid.jqGrid('GridUnload');
            }

            $("textarea[name='resultArea']").hide();
            $("#divPropResultsTable").show();

            // Prepare jqgrid
            let currentModel = this.model.get('currentActionDetails');
            const columnModel = currentModel.ActionXML.Action.Receive.Parameter.map((parameter) => {
                return {
                    name: parameter._value,
                    editable: false,
                    hidden: false
                }
            });

            let gridSendObject = util.getGridObject(this, {
                colModel: columnModel,
                colNames: currentModel.ActionXML.Action.Receive.Parameter.map((parameter) => {
                    return parameter._name;
                }),
                scrollOffset: 0,
                autoWidth: false,
                data: data,
                gridComplete: function () {
                    const $cgrid = $(this);
                    self._overrideGridStyling($cgrid);
                    self._alignGridHeaders($cgrid, columnModel);
                }
            });

            $grid.jqGrid('clearGridData').jqGrid(gridSendObject);
            this._updateModalLayout();

        }
        else {
            $("textarea[name='resultArea']").text('No records were returned.');
            $("textarea[name='resultArea']").show();
            $("#divPropResultsTable").hide();
        }
        spinner.stop();
    }

    renderResultsGridGoogle(results){
        let responseObject = results;
        let resultItemsToRender = [];
        let currentModel = this.model.get('currentActionDetails');        
        
        const logEntry = { };

        // It's a Select action
        if (currentModel.Type === '85' || currentModel.Type === '81') {
            if (responseObject && responseObject.Rows && responseObject.Headers.Row && responseObject.Rows.Row) {
                //Map the headers (column names) with the column identifier per each returned row
                let resultItemsHeadersKeys = Object.keys(responseObject.Headers.Row);
                let _resultItemsToRender = responseObject.Rows.Row instanceof Array ? responseObject.Rows.Row : [responseObject.Rows.Row];
                $.each(_resultItemsToRender, (idx, row) => {
                    let newRow = {};
                    $.each(resultItemsHeadersKeys, (idx2, key) => {
                        newRow[responseObject.Headers.Row[key]] = row[key];
                    });
                    resultItemsToRender.push(newRow);
                });

                logEntry.result = "Success. " + `Returned records: ${resultItemsToRender.length}`;
            }
            else {
                logEntry.responseData = "No records were returned.";
            }

            const data = [];

            // For each record
            _.forEach(resultItemsToRender, (field, index) => {
                let row = {};

                let i = 0;
                currentModel.ActionXML.Action.Receive.Parameter.forEach((rp) => {
                    let properties = Object.getOwnPropertyNames(field);
                    properties.forEach((p) => {
                        if (p.includes(rp._value)) {
                            row[rp._value] = field[p];
                            i++;
                        }
                    });

                })
                data.push(row);
            });
            this.createResultsGrid(data);

        } else if (responseObject === '') {
            let actionResultMessage;
            if (currentModel.Type === '82') {
                        actionResultMessage = "inserted";
                }
                logEntry.responseData = `Record ${actionResultMessage} successfully`;
                
        }else if(responseObject.SUCCESS) {
             let actionResultMessage;
                if(currentModel.Type === '83'){
                   actionResultMessage = "Updated";
                }else{
                   actionResultMessage = "Deleted";  
                }
                logEntry.responseData = `${actionResultMessage} records: ${responseObject.SUCCESS}`;
        } 
        else if(responseObject.response.error) {
            logEntry.responseData = responseObject.response.error;
            this._logError(null, logEntry);
            return;
        }

        this._logSuccess(logEntry);       
    }

    renderResultsGrid(results) {
        let responseObject = null;
        
        try {
            responseObject = xjService.toJSON(results.RESULT.RESPONSE['#cdata-section']);
        }
        catch (ex) {
            responseObject = xjService.toJSON(results[0].outerHTML);
        }

        let resultItemsToRender = [];
        let currentModel = this.model.get('currentActionDetails');        
        
        if (responseObject) {
            const logEntry = {
                responseData: "",
                code: "200"
            };

            // It's a Select action
            if (currentModel.Type === '11' || currentModel.Type === '13' || currentModel.Type === '21' || currentModel.Type === '71') {
                if (responseObject.response.record) {
                    resultItemsToRender = responseObject.response.record instanceof Array ? responseObject.response.record : [responseObject.response.record];
                    logEntry.result = `Success. Returned records: ${resultItemsToRender.length}`;
                }
                else {
                    logEntry.code = 200;
                    logEntry.responseData = "No records were returned.";
                }

                const data = [];

                // For each record
                _.forEach(resultItemsToRender, (field, index) => {
                    let row = {};

                    let i = 0;
                    currentModel.ActionXML.Action.Receive.Parameter.forEach((rp) => {
                        row[rp._value] = field.value instanceof Array ? field.value[i] : field.value;
                        i++;
                    })

                    data.push(row);
                });

                this.createResultsGrid(data);
            }
            else {
                if (responseObject.response.success) {

                    logEntry.code = responseObject.response.success;

                    let actionResultMessage;
                    switch (currentModel.Type) {
                        case '12':
                        case '22':
                        case '72':
                            actionResultMessage = "updated";    
                            break;    
                        case '14':
                        case '23':
                        case '73':
                            actionResultMessage = "deleted";    
                            break;   
                        case '70':
                            actionResultMessage = "inserted";
                            break;
                        default:
                            actionResultMessage = "inserted";
                            break;
                    }
                    
                    logEntry.responseData = `${responseObject.response.success} records were ${actionResultMessage}.`;
                } else if(responseObject.response.error) {
                    logEntry.responseData = responseObject.response.error;
                    this._logError(null, logEntry);
                    return;
                }
            }

            this._logSuccess(logEntry);
        }       
                  
    }

    findOperationResponseSOAPWebService(responseObject, operationName) {
        if (!responseObject || typeof responseObject !== 'object' || !operationName) {
            return null;
        }

        const searchPattern = operationName + "Response";
        // Find property that starts with operationName + "Response"
        let matchingKey = Object.keys(responseObject).find(key => 
            key.startsWith(searchPattern)
        );
        
        if (matchingKey) {
            return responseObject[matchingKey];            
        }else{
            if (responseObject[operationName] && responseObject[operationName]["Response"]){
                return responseObject[operationName]["Response"];
            }
        }
    }
    
    // SOAP specific response
    renderResultsGridWebService(results, logEntry) {
       
        // Current action model, required to read request parameters and response structure, etc
        let currentModel = this.model.get('currentActionDetails');        
        
        // Take only body of response
        let cleanedResult = results.RESULT.RESPONSE['#cdata-section'];

        //Remove all namespaces prefixes
        cleanedResult = cleanedResult.replace(/<[A-Za-z0-9]*:/g, '<').replace(/<\/[A-Za-z0-9]*:/g, '</');

        let resultWithoutDotsInNames = this.removeDotsFromXmlTagsNames(cleanedResult);
        // Read only body of message        
        let responseObjectWithoutDotsInNames = xjService.toJSON(resultWithoutDotsInNames)["Envelope"]["Body"];
        let responseObject = xjService.toJSON(cleanedResult)["Envelope"]["Body"];
        let responseObjectHeader = xjService.toJSON(cleanedResult)["Envelope"]["Header"];
        let gridMessage = "Results: Error";
        let errorResponse = false;
        let responseBody;
        
        switch (results.RESULT.ERROR.CODE) {
            case "0":
                responseBody = this.findOperationResponseSOAPWebService(responseObject, currentModel.ActionXML.Action._operation);
                logEntry.responseData = cleanedResult;

                if (responseBody) { //If no records were returned then it will be taken as error as in Flash
                    this._logSuccess(logEntry);
                    sessionStorage.setItem(constants.WS_ACTION_RESPONSE_STORAGE_KEY_PREFIX + currentModel.ActionXML.Action._id, cleanedResult); //Store the response XML to be used in Auto Complete
                }else{
                    logEntry.responseData = gridMessage;
                    this._logError(null, logEntry);
                    errorResponse = true;
                }
                break;
            case "2":
                const errorMsg2 = 'The web service could not be reached, did not accept the request or returned an unexpected response\nYou are no longer logged in.';
                logEntry.responseData = errorMsg2;
                this._logError(null, logEntry);
                errorResponse = true;
                break;
            default:
                let errorMsgDefault = 'The web service could not be reached, did not accept the request or returned an unexpected response.';
                if (responseObject.Fault && responseObject.Fault.Reason && responseObject.Fault.Reason.Text && responseObject.Fault.Reason.Text['$']) {
                    errorMsgDefault = responseObject.Fault.Reason.Text['$'];
                }    
                logEntry.responseData = errorMsgDefault;
                this._logError(null, logEntry);         
                errorResponse = true;
                break;
        }
        
        if (errorResponse){
            return;
        }

        let columns = [];
        responseBody = responseObjectWithoutDotsInNames[currentModel.ActionXML.Action._operation + 'Response'] || responseObjectWithoutDotsInNames[currentModel.ActionXML.Action._operation]['Response'];

        if (responseObjectHeader){
            // Process Header
            currentModel.ActionXML.Action.Receive.Parameter.forEach((parameter) => {
                // locates property deeply descended from context items
                let xpath = '.' + this.convertAttribute(parameter._value);
                if (xpath.indexOf('*') === -1){
                    return;
                }
                
                xpath = xpath.replaceAll('*', '');

                // locate
                let res = jspath(xpath, responseObjectHeader);

                // Second attempt, search for value of a key, the inner text between tags does not always appear, but it's inside $ attr
                if (res.length === 1 && res[0][constants.JXON_VALUE_KEY]) {
                    // Try VALUE_KEY
                    res = [res[0][constants.JXON_VALUE_KEY]];
                }
                
                columns.push({
                    column: parameter._value,
                    values: res.map(x => {
                        let returnValue = {};
                        returnValue[parameter._value] = x;

                        return returnValue;
                    })
                });    
            });
        }
        
        if (!responseBody){
            responseBody = this.findOperationResponseSOAPWebService(responseObject, currentModel.ActionXML.Action._operation);
        }

        // For each column
        currentModel.ActionXML.Action.Receive.Parameter.forEach((parameter) => {
            // locates property deeply descended from context items
            let xpath = '.' + this.convertAttribute(parameter._value).replaceAll(constants.CONNECTION_DOT_PLACEHOLDER, '');
            if (xpath.indexOf('*') >= 0){
                return;
            }

            // locate
            let res = jspath(xpath, responseBody);

            // Second attempt, search for value of a key, the inner text between tags does not always appear, but it's inside $ attr
            if (res.length === 1 && res[0][constants.JXON_VALUE_KEY]) {
                // Try VALUE_KEY
                res = [res[0][constants.JXON_VALUE_KEY]];
            }
            
            columns.push({
                column: parameter._value,
                values: res.map(x => {
                    let returnValue = {};
                    returnValue[parameter._value] = x;

                    return returnValue;
                })
            });    
        });
        
        let result = [];
        columns.forEach((column) => {
            result = _.merge(result, column.values);
        })
        
        this.createResultsGrid(result);
       
    }

    removeDotsFromXmlTagsNames(xmlString) {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
        
        const allElements = xmlDoc.getElementsByTagName('*');
        
        const elementsArray = Array.from(allElements);
        
        elementsArray.forEach(element => {
          if (element.tagName.includes('.')) {
            const newTagName = element.tagName.replace(/\./g, '');
            
            const newElement = xmlDoc.createElement(newTagName);
            
            Array.from(element.attributes).forEach(attr => {
              newElement.setAttribute(attr.name, attr.value);
            });
            
            while (element.firstChild) {
              newElement.appendChild(element.firstChild);
            }
            
            element.parentNode.replaceChild(newElement, element);
          }
        });
        
        const serializer = new XMLSerializer();
        return serializer.serializeToString(xmlDoc);
      }

    renderResultsGridWebServicePOST(results, logEntry) {

        // Current action model, required to read request parameters and response structure, etc
        let currentModel = this.model.get('currentActionDetails');   
        
        // Take only body of response
        let cleanedResult = results.RESULT.RESPONSE['#cdata-section'];

        logEntry.result = cleanedResult;        
        
        if (cleanedResult) {
            this._logSuccess(logEntry);
        }        
        else {
            // Show error response
            logEntry.responseData = "Received an empty or invalid response body.";
            this._logError(null, logEntry);
            return;
        }
       

        if (currentModel.Type === "30"){ //If is string result type
            // Only one result row/column
            this.createResultsGrid([{
                Result: cleanedResult
            }])
        }else{
            let columns = [];

            let resultWithoutDotsInNames = this.removeDotsFromXmlTagsNames(cleanedResult);

            let responseObject = xjService.toJSON(resultWithoutDotsInNames);
            if (responseObject){
                sessionStorage.setItem(constants.WS_ACTION_RESPONSE_STORAGE_KEY_PREFIX + currentModel.ActionXML.Action._id, cleanedResult); //Store the response XML to be used in Auto Complete
            }
            
            currentModel.ActionXML.Action.Receive.Parameter.forEach((parameter) => {
                // locates property deeply descended from context items
                let xpath = '.' + this.convertAttribute(parameter._value).replaceAll(constants.CONNECTION_DOT_PLACEHOLDER, '.');
                // locate
                let res = jspath(xpath, responseObject);

                // Second attempt, search for value of a key, the inner text between tags does not always appear, but it's inside $ attr
                if (res.length === 1 && res[0][constants.JXON_VALUE_KEY]) {                    
                    res = [res[0][constants.JXON_VALUE_KEY]];
                }
                
                columns.push({
                    column: parameter._value,
                    values: res.map(x => {
                        let returnValue = {};
                        returnValue[parameter._value] = x;

                        return returnValue;
                    })
                });    
            });
            
            let result = [];
            columns.forEach((column) => {
                result = _.merge(result, column.values);
            })
            
            this.createResultsGrid(result);
        }

    }

    // Replace @ with prefix used when converting XML attribute to JSON property    
    convertAttribute(path) {
        if (path.indexOf('@') !== -1) {
            return path.replace('@', '.' + constants.XATTR_PREFIX);
        }
        
        return path;
    }

    

    resizeTableColumns(self = this) {
        let dialog =$(constants.DIALOG_ID);
        let grid = $(self._gridEl)
        let width = dialog.width() - 10; 

        let columnsWidth = 0;
        grid.find('.jqgfirstrow').children().each((i, e) => {
            if (i > 0) {
                columnsWidth += $(e).width();
            }
        });

        let lastChild =  grid.find('.jqgfirstrow').children().last();
       
        $('#propMapFormVersionsTable_MapMajorVersion').width(lastChild.width() + (width - columnsWidth -10));
        lastChild.width(lastChild.width() + (width - columnsWidth - 10));

       grid.jqGrid("setGridWidth", width, false); 
    }

    closeModal() {
        $(constants.DIALOG_ID).dialog("destroy");
        this.remove();
    }

    _resizejqGrid($grid, offset = 0){
        //Force the table width       
        const $gridParentContainer = $grid.closest('.ui-jqgrid').parent();
        const parentWidth = $gridParentContainer.width();
        $grid.jqGrid('setGridWidth', parentWidth);
    }

    bindEvents() {
        const self = this;
        $(constants.DIALOG_ID).find('#testConn').on("click", e => this.performConnect(e));

        $(window).on("resize", function () {
            if ($(constants.DIALOG_ID).dialog("isOpen")) {
                
                //Set modal max heigh so its not bigger than the current window
                const maxHeight = window.innerHeight - 40;
                $(constants.DIALOG_ID).dialog("option", "maxHeight", maxHeight);

                self._updateModalLayout();
            }
        });

        $('#logTabs a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
        
            const targetPaneID = $(e.target).attr('href');
            const $textarea = $(targetPaneID).find('textarea');
    
            if ($textarea.length) {
                const el = $textarea[0];
                el.style.height = 'auto';
                el.style.height = el.scrollHeight + 'px';
            }

            self._reCenterDialog();
        });

        $('#downloadResponse').on('click', function(e) {
            e.stopPropagation(); 
            e.preventDefault();
            
            const content = $('#response-pane textarea').val();
            const logTime = $('#logTabsContent').data('log-time') || "";
            const filename = `${self.actionName}_WebResponse_${logTime}.txt`;
            util.downloadAsFile(content, filename);
        });

        $('#downloadRequest').on('click', function(e) {
            e.stopPropagation(); 
            e.preventDefault();
            
            const content = $('#request-pane textarea').val();
            const logTime = $('#logTabsContent').data('log-time') || "";
            const filename = `${self.actionName}_WebRequest_${logTime}.txt`;
            util.downloadAsFile(content, filename);
        });
    }

    unbindEvents() {
        $(constants.DIALOG_ID).find('#testConn').off();
        
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.empty();
            if (this.template) {
                this.$el.html(this.template(this.model.toJSON()));
            }
            this.renderDialog(resolve, reject);
            this.renderParametersGrid();
            this.renderTestActionLogGrid();
            this._updateModalLayout();
        });
    }

    handleByteFileUpload(rowId, gridSelector) {
        const self = this;
        
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.style.display = 'none';
    
        fileInput.onchange = (e) => {
            const file = e.target.files[0];
            if (!file) {
                document.body.removeChild(fileInput);
                return;
            }
    
            const reader = new FileReader();
    
            reader.onload = (readerEvent) => {
                const base64String = readerEvent.target.result;
                const fileName = file.name;
                
                console.log(`File selected: ${fileName}`);
                $(gridSelector).jqGrid('setCell', rowId, '_value', fileName);
    
                let currentModelValues = self.model.get('testValues');
                if (currentModelValues[rowId]) {
                    currentModelValues[rowId]._value = base64String;
                    currentModelValues[rowId]._fileName = fileName;
                }
                
                self.model.set('testValues', currentModelValues, { silent: true });
                self.model.set('hasChanges', true, { silent: true });
    
                document.body.removeChild(fileInput);
            };
            
            reader.onerror = (error) => {
                console.error('Error reading file:', error);
                NotificationService.error('Error reading the selected file.');
                document.body.removeChild(fileInput);
            };
    
            reader.readAsDataURL(file);
        };
    
        document.body.appendChild(fileInput);
        fileInput.click();
    }

    testWebServiceActionREST(connectionObject, currentActionValues, testValues){
        let connectionURL = connectionObject.Connection._url;
        let actionEndpoint = currentActionValues._actionEndpoint;
        const action = currentActionValues._type;
        const parameters = currentActionValues.Send.Parameter;
        const requestType = currentActionValues._requestType;
        const responseType = currentActionValues._responseType;
        const userName = connectionObject.Connection._username;
        const password = connectionObject.Connection._password;
        const additionalContentType = currentActionValues._additionalContentType;

        let actionName = '';
        let requestObject = [];
        let bodyParameters = parameters.filter(param => param._placement === 'pathbody' || param._placement === 'body');

        let xmlStringBodyParams = this.buildXMLStringFromWSParamName(bodyParameters, testValues);
        xmlStringBodyParams = this.validateXMLArrayString(xmlStringBodyParams, bodyParameters);
        xmlStringBodyParams = encodeURIComponent(xmlStringBodyParams);

        switch (action) {
            case constants.CONNECTION_REST_GET:
                actionName = 'GET';
                break;
            case constants.CONNECTION_REST_POST:
                actionName = 'POST';
                break;
            case constants.CONNECTION_REST_PUT:
                actionName = 'PUT';
                break;
            case constants.CONNECTION_REST_DELETE:
                actionName = 'DELETE';
                break;
            default:
                // Error
                console.log('Not supported');
                break;
        }

        // loop for each parameter
        parameters.forEach(parameter => {
            const testValueData = testValues.filter(i => i._id === parameter._id)[0];

            let valueForPayload;
            if (parameter._dataType === 'System.Byte' && testValueData) {
                const base64String = testValueData._value || '';
                const base64Content = base64String.split(',')[1] || '';
        
                valueForPayload = {
                    fileName: testValueData._fileName,
                    fileContent: base64Content
                };
        
            } else {
                valueForPayload = testValueData ? testValueData._value : '';
            }
            
            requestObject.push({
                    name: parameter._value,
                    value: valueForPayload,
                    placement: parameter._placement,
                    path: parameter._path,
                    dataType: parameter._dataType,
                    isNullable: parameter._isNullable
            })

        });

       

        let testActionObject = {
            URL: connectionURL,
            method: actionName,
            actionEndpoint: actionEndpoint,
            requestType: requestType,
            responseType: responseType,
            jsonRequestObject: JSON.stringify(requestObject),
            xmlStringBodyParams: xmlStringBodyParams,
            webServiceType: actionName,
            targetNamespace: '',
            username: userName,
            password: password,
            additionalContentType: additionalContentType,
            connectionGUID: connectionObject.Connection._id
        };

        const logEntry = {};

        RestService.checkRESTAction(testActionObject).then((result) => {
            setTimeout(() => { 
                const metadata = this._getMetadata(result.RESULT.METADATA);
                logEntry.responseData = metadata.response;
                logEntry.requestData = metadata.request;
                this.renderResultsGridWebServiceREST(result, logEntry);
             }, 10);           
        }).catch((err => {

            if(err.METADATA){
                const metadata = this._getMetadata(err.METADATA);
                logEntry.responseData = metadata.response;
                logEntry.requestData = metadata.request;
            }
            const error = err?.ERROR || err;
            this._logError(error, logEntry);
        }));
    }

    //Transform dot notation parameter name to XML array string
    validateXMLArrayString(xmlStringBodyParams, parameters) {
        if (parameters && parameters.length > 0) {
            $.each(parameters, function (index, _parameter) {
                let paramNameSplit = _parameter._value.split(".");
                    for (let i = paramNameSplit.length - 1; i >= 0; i--) {
                        if (paramNameSplit[i].includes('[]')){
                            let splittedName = paramNameSplit[i].replace('[]', '').split('@')[0];
                            xmlStringBodyParams = xmlStringBodyParams.replace('<'+splittedName+'>', '<'+splittedName+" json:Array='true'>")
                        }
                    }
            });
        }

        return xmlStringBodyParams;
    }

    _getMetadata(data){
        const metadata = data ? JSON.parse(data) : null;
        let request = "", response = "";
        
        if(metadata){
            request = atob(metadata.request);
            response = atob(metadata.response);
        }

        return {request,response};
    }
   
    renderResultsGridWebServiceREST(results) {

        const metadata = this._getMetadata(results.RESULT.METADATA);
       
        const logEntry = {
            responseData: metadata.response,
            requestData: metadata.request  
        };

        // Current action model, required to read request parameters and response structure, etc
        let currentModel = this.model.get('currentActionDetails'); 
        let resultsJSON;
        if (currentModel.ActionXML.Action._responseType === 'raw') {
            resultsJSON = util.encodeForHTMLNotification(results.RESULT.RESPONSE['#cdata-section']);
        } else if (currentModel.ActionXML.Action._responseType === 'binary') {
            let splittedResults = results.RESULT.RESPONSE['#cdata-section'].split('&');
            resultsJSON = {
                fileName: splittedResults[0],
                base64: splittedResults[1].substring(0, this.maxLength)
            };
            
        } else if (currentModel.ActionXML.Action._responseType === 'json'){
            // Validate if response has more than one root element  (PFCustomRoot)
            let resultsXML = results.RESULT.RESPONSE['#cdata-section'];
            let rootName = resultsXML.substring(
                resultsXML.lastIndexOf("/") + 1, 
                resultsXML.lastIndexOf(">")
            );

            const regExp = new RegExp(rootName, "gi");
            let count = (resultsXML.match(regExp) || []).length;

            if (count > 1) {
                // Add a new root element
                resultsXML = `<Root>${resultsXML}</Root>`;
                resultsJSON = xjService.toJSON(resultsXML).Root[rootName];
            } else {
                resultsJSON = xjService.toJSON(resultsXML)[rootName];
            }          
        } else if (currentModel.ActionXML.Action._responseType === 'xml') {
            let resultsXML = results.RESULT.RESPONSE['#cdata-section'];

            // Validate if response is xml
            if (resultsXML.substring(0,1) === '<')
            {
                let rootName = resultsXML.substring(
                    resultsXML.lastIndexOf("/") + 1, 
                    resultsXML.lastIndexOf(">")
                );
    
                resultsJSON =  xjService.toJSON(resultsXML)[rootName];
            } else {
                // Consider as json
                resultsJSON = JSON.parse(results.RESULT.RESPONSE['#cdata-section']);  
            }
            
        } else {
            resultsJSON = JSON.parse(results.RESULT.RESPONSE['#cdata-section']);  
        }
        
        
        if (resultsJSON && resultsJSON !== '') {

            //Set in session storage
            let stringJSON = "";
            
            stringJSON = JSON.stringify(resultsJSON, undefined, 4);
            
            if(currentModel.ActionXML.Action._responseType === 'xml'){
                const obj = {"Parameters": resultsJSON};
                stringJSON = xjService.xmlToString(xjService.jsToXml(obj));
            }

            const size = Buffer.byteLength(stringJSON);
            
            //The size should be less than 5MB to store in sessionStorage
            if(size < 5000000){
                sessionStorage.setItem(constants.WS_ACTION_RESPONSE_STORAGE_KEY_PREFIX + currentModel.ActionXML.Action._id, stringJSON);
            }

            if(results.STATUSCODE)
            {
                const statusCode = results.STATUSCODE;
                let resultMessage;

                // This switch(true) is a clean way to handle ranges
                switch (true) {
                    case (statusCode >= 100 && statusCode <= 199):
                        resultMessage = "Information response";
                        break;
                    case (statusCode <= 299): // 200-299
                        resultMessage = "Successful response";
                        break;
                    case (statusCode <= 399): // 300-399
                        resultMessage = "Redirection message";
                        break;
                    case (statusCode <= 499): // 400-499
                        resultMessage = "Client error response";
                        break;
                    case (statusCode <= 599): // 500-599
                        resultMessage = "Server error response";
                        break;
                    default:
                        resultMessage = "Unknown response";
                }

                logEntry.result = resultMessage;
                logEntry.code = statusCode;

            }

            this._logSuccess(logEntry);

        } else {
            // Show error response
            logEntry.responseData = "No data returned.";
            this._logError(null, logEntry);
        }
      
        if (currentModel.ActionXML.Action._responseType === 'raw') {
            // Only one result row/column
            this.createResultsGrid([{
                Result: resultsJSON
            }]);
        } else {
            let columns = [];
            let resultsXML = results.RESULT.RESPONSE['#cdata-section'];

            currentModel.ActionXML.Action.Receive.Parameter.forEach((parameter) => {
                let xpath;
                if (currentModel.ActionXML.Action._responseType === 'json' && 
                    currentModel.ActionXML.Action.Receive.Parameter.length === 1 &&
                    resultsXML.indexOf(constants.PERFECTAPPS_ROOT_WITH_SIMPLE_VALUES) != -1){
                    xpath = '.' + constants.PERFECTAPPS_ROOT_WITH_SIMPLE_VALUES;
                }else{// locates property deeply descended from context items
                    xpath = '.' + this.convertAttribute(parameter._value.replace('[]', ''));
                }
                
                // locate
                let res = jspath(xpath, resultsJSON);

                // Second attempt, search for value of a key, the inner text between tags does not always appear, but it's inside $ attr
                if (res.length === 1 && res[0][constants.JXON_VALUE_KEY]) {                    
                    res = [res[0][constants.JXON_VALUE_KEY]];
                }
                
                columns.push({
                    column: parameter._value,
                    values: res.map(x => {
                        let returnValue = {};
                        let xAux = x;
                        if (typeof x === 'object'){ //It's a single element array, we need to retrieve the actual value
                            xAux = x.$;
                        }
                        returnValue[parameter._value] = xAux;

                        return returnValue;
                    })
                });    
            });
            
            let result = [];
            columns.forEach((column) => {
                result = _.merge(result, column.values);
            })

            this.createResultsGrid(result);
        }        

    }

    BuildXMLStructure(parameters, testValues, finalObject) {
        
        let paramsTemp = parameters.map((param) => {
            param._valueTemp = param._valueTemp ? param._valueTemp : param._value.replace('{', '').replace('}', '');
            return param;
        });

        // 1 - Filter wich elements has no . (only one level)
        paramsTemp = paramsTemp.filter((i) => {
            if (!i._valueTemp.includes('.')){
                return i;
            }
        }); 

        // 2 - Get name of elements
        let paramsGrouped = _.mapValues(paramsTemp, (param) => {
            param._main = param._valueTemp.split('@')[0].replace('*', '');
            return param;
        });
        paramsGrouped =  _.mapValues(_.groupBy(paramsGrouped, '_main'),
        plist => plist.map(param => _.omit(param, '_main')));

        const groups = Object.keys(paramsGrouped);
        groups.forEach(group => {
            // 3 - Wich of theese elements has no @ (count)
            let countElements = paramsGrouped[group].filter((i) => !i._valueTemp.includes('@')).length;

            // 4 - If count < 2 => only one element, create object
            //             else => it's an array
            if (countElements < 2) {

                finalObject[group] = {};
                
                // 5a - Create properties of main object
                const properties = paramsTemp.filter((i) => i._valueTemp.includes('@'));
                let propName = '';
                properties.forEach(prop => {
                    propName = prop._valueTemp.split('@')[1];
                    finalObject[group]["_" + propName] = testValues.filter(i => i._id === prop._id)[0]._value;
                });

                // Set value if has something
                const value = testValues.filter(i => i._id === paramsGrouped[group][0]._id)[0]._value;
                if (value) {
                    finalObject[group]['$'] = value;
                }
                
            } else {
                finalObject[group] = [];
                let countField = 0;

                // 5a - Create objects to push in final object
                paramsTemp.forEach(param => {
                    const propName = param._valueTemp.split('@')[1];
                   
                    if (!propName && !finalObject[group][countField])
                    {
                        // Set value only if has something
                        const value = testValues.filter(i => i._id === param._id)[0]._value;
                        if (value) {
                            finalObject[group].push({
                                $: value
                            });
                            countField++;
                        }
                    } else {
                        // Set property if has a value
                        const value = testValues.filter(i => i._id === param._id)[0]._value;
                        if (value) {
                            finalObject[group][countField - 1]['_' + propName] = value;
                        }
                    }
                });
                
            }

            // 6 - Create new list of parameters without first node (all the childrens) and send recursively
            let paramsChildren = parameters.filter((i) => i._valueTemp.includes('.'));
            paramsChildren = paramsChildren.map((param) => {
                // Take the value after dot (children)
                param._valueTemp = param._valueTemp.substring(param._valueTemp.indexOf('.') + 1);
                return param;
            });

            if (paramsChildren.length > 0) {
                this.BuildXMLStructure(paramsChildren, testValues, finalObject[group]);
            }

        });

        return finalObject;

    }

}

export default TestActionModalView;